import * as service from './service'

export default {
  namespace: 'widgetMallSureOrder',
  state: {
    payAgentData: [],
    getOrderData: {},
    backOrderData: {},
    levelInfoData: {},
    gloryInfoData: {},
    memberDataInfo: {}
  },
  effects: {
    * getPayAgentList ({ payload }, { call, put }) {
      const res = yield call(service.getPayAgentList, payload)
      yield put({
        type: 'save',
        payload: {
          payAgentData: res.data.data
        }
      })
      return res.data
    },
    * getCreatOrderData ({ payload }, { call, put }) {
      const res = yield call(service.getCreatOrderData, payload)
      yield put({
        type: 'save',
        payload: {
          getOrderData: res.data.data
        }
      })
      return res.data
    },
    * creatOrderData ({ payload }, { call, put }) {
      const res = yield call(service.creatOrderData, payload)
      yield put({
        type: 'save',
        payload: {
          backOrderData: res.data.data
        }
      })
      return res.data
    },
    * getLevelInfo ({ payload }, { call, put }) {
      const res = yield call(service.getLevelInfo, payload)
      yield put({
        type: 'save',
        payload: {
          levelInfoData: res.data.data
        }
      })
      return res.data
    },
    * getGloryInfo ({ payload }, { call, put }) {
      const res = yield call(service.getGloryInfo, payload)
      yield put({
        type: 'save',
        payload: {
          gloryInfoData: res.data.data
        }
      })
      return res.data
    },
    * getMemberInfo ({ payload }, { call, put }) {
      const res = yield call(service.getMemberInfo, payload)
      yield put({
        type: 'save',
        payload: {
          memberDataInfo: res.data.data
        }
      })
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
